import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { IconArrowChevronRightDiagonal } from '@costar-ui/icons/csg/IconArrowChevronRightDiagonal';
import { IconExpand } from '@costar-ui/icons/csg/IconExpand';
import { mergeRefs } from '@costar-ui/utils';
import React__default, { forwardRef, useMemo } from 'react';
import { useComponentVariant } from '../../theme/variant.context.esm.js';
import { useComponentTheme } from '../../theme/theme.context.esm.js';
import useTextEllipsisState from '../../hooks/use-text-ellipsis-state.esm.js';

var _excluded = ["variant"],
  _excluded2 = ["_as", "alignItems", "canShrink", "direction", "fullHeight", "fullWidth", "gap", "gapCol", "gapRow", "inline", "justify", "padding", "paddingX", "paddingY", "children", "className", "size", "testId", "title", "ellipsis", "variant", "showLeftIcon", "showRightIcon", "weight", "fontFamily", "inheritColor", "inheritFontSize"];
var leftIcon = /*#__PURE__*/React__default.createElement(IconExpand, {
  size: '1em'
});
var rightIcon = /*#__PURE__*/React__default.createElement(IconArrowChevronRightDiagonal, {
  size: '1em'
});
var Anchor = /*#__PURE__*/forwardRef(function Link(_ref, ref) {
  var _ref$variant = _ref.variant,
    variantPreSet = _ref$variant === void 0 ? 'primary-sm' : _ref$variant,
    props = _objectWithoutProperties(_ref, _excluded);
  var variantProps = useComponentVariant('Anchor', variantPreSet);
  var theme = useComponentTheme('Anchor');
  var _variantProps$props = _objectSpread2(_objectSpread2({}, variantProps), props),
    _as = _variantProps$props._as,
    _variantProps$props$a = _variantProps$props.alignItems,
    alignItems = _variantProps$props$a === void 0 ? 'center' : _variantProps$props$a,
    canShrink = _variantProps$props.canShrink,
    direction = _variantProps$props.direction,
    fullHeight = _variantProps$props.fullHeight,
    fullWidth = _variantProps$props.fullWidth,
    gap = _variantProps$props.gap,
    gapCol = _variantProps$props.gapCol,
    gapRow = _variantProps$props.gapRow,
    inline = _variantProps$props.inline,
    justify = _variantProps$props.justify,
    padding = _variantProps$props.padding,
    paddingX = _variantProps$props.paddingX,
    paddingY = _variantProps$props.paddingY,
    children = _variantProps$props.children,
    _variantProps$props$c = _variantProps$props.className,
    className = _variantProps$props$c === void 0 ? '' : _variantProps$props$c,
    size = _variantProps$props.size,
    testId = _variantProps$props.testId,
    _title = _variantProps$props.title,
    ellipsis = _variantProps$props.ellipsis,
    variant = _variantProps$props.variant,
    showLeftIcon = _variantProps$props.showLeftIcon,
    showRightIcon = _variantProps$props.showRightIcon,
    _variantProps$props$w = _variantProps$props.weight,
    weight = _variantProps$props$w === void 0 ? 'normal' : _variantProps$props$w,
    _variantProps$props$f = _variantProps$props.fontFamily,
    fontFamily = _variantProps$props$f === void 0 ? 'default' : _variantProps$props$f,
    inheritColor = _variantProps$props.inheritColor,
    inheritFontSize = _variantProps$props.inheritFontSize,
    rest = _objectWithoutProperties(_variantProps$props, _excluded2);
  var _useTextEllipsisState = useTextEllipsisState(ellipsis, children, _title),
    localRef = _useTextEllipsisState.localRef,
    showTitle = _useTextEllipsisState.showTitle,
    title = _useTextEllipsisState.title,
    handleOnMouseOver = _useTextEllipsisState.handleOnMouseOver;
  var classes = useMemo(function () {
    return theme({
      alignItems: alignItems,
      canShrink: canShrink,
      direction: direction,
      fullHeight: fullHeight,
      fullWidth: fullWidth,
      gap: gap,
      gapCol: gapCol,
      gapRow: gapRow,
      inline: inline,
      justify: justify,
      padding: padding,
      paddingX: paddingX,
      paddingY: paddingY,
      className: className,
      size: size,
      variant: variant,
      weight: weight,
      fontFamily: fontFamily,
      inheritColor: inheritColor,
      inheritFontSize: inheritFontSize
    });
  }, [theme, alignItems, canShrink, direction, fullHeight, fullWidth, gap, gapCol, gapRow, inline, justify, padding, paddingX, paddingY, className, size, variant, weight, fontFamily, inheritColor, inheritFontSize]);
  var Component = _as !== null && _as !== void 0 ? _as : 'a';
  return /*#__PURE__*/React__default.createElement(Component, _extends({
    className: "csg-tw-link ".concat(classes),
    ref: mergeRefs(ref, localRef),
    "data-testid": testId,
    title: showTitle ? title !== null && title !== void 0 ? title : '' : '',
    onMouseOver: handleOnMouseOver
  }, rest), showLeftIcon ? leftIcon : null, children, showRightIcon ? rightIcon : null);
});
Anchor.displayName = 'Anchor';
var Anchor$1 = Anchor;

export { Anchor$1 as default };
//# sourceMappingURL=anchor.esm.js.map
